import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const SpecialtiesSection = () => {
  const specialties = [
    {
      icon: "🎂",
      title: "Layer Cake",
      price: "à partir de 35 €",
      portions: "10 parts",
      description: "Layer cakes élégants et personnalisés, parfaits pour anniversaires et mariages",
      image: "/images/wedding1.jpg"
    },
    {
      icon: "🍓",
      title: "Number Cake",
      price: "à partir de 40 €",
      portions: "12 parts",
      description: "Gâteaux en forme de chiffres décorés avec fleurs, macarons et fruits frais",
      image: "/images/cupcakes2.jpg"
    },
    {
      icon: "🧁",
      title: "Cupcakes",
      price: "Boîte de 4 à partir de 6€",
      portions: "boîte de 4 minimum",
      description: "Des cupcakes raffinés, au glaçage soyeux et aux saveurs uniques. Parfaits pour vos événements",
      image: "/images/cupcakes-hero.jpg"
    },
    {
      icon: "🍮",
      title: "Verrines",
      price: "à partir de 2 €/pièce",
      portions: "lot de 6 minimum",
      description: "Douceurs à la cuillère, légères et fondantes pour vos réceptions",
      image: "/images/layercake1.jpg"
    },
    {
      icon: "🍱",
      title: "Bento Cake",
      price: "à partir de 20 €",
      portions: "6 parts",
      description: "Découvrez nos élégants Bento Cakes — parfaits pour vos petits plaisirs sucrés et vos occasions spéciales",
      image: "/images/bento-hero.jpg"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-pink-50/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nos créations phares
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Layer cakes, number cakes, cupcakes, verrines et gâteaux personnalisés — 
            chaque douceur est réalisée sur commande, avec des ingrédients de qualité.
          </p>
        </div>

        {/* Specialties Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {specialties.map((specialty, index) => (
            <Card 
              key={index} 
              className="group hover:shadow-elegant transition-smooth border-pink-100 hover:border-primary/30 overflow-hidden"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={specialty.image}
                  alt={specialty.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-smooth"
                />
                <div className="absolute top-4 left-4">
                  <div className="bg-white/90 backdrop-blur-sm rounded-full w-12 h-12 flex items-center justify-center text-2xl shadow-sm">
                    {specialty.icon}
                  </div>
                </div>
                <div className="absolute top-4 right-4">
                  <Badge className="bg-primary text-white shadow-sm">
                    {specialty.portions}
                  </Badge>
                </div>
              </div>
              
              <CardHeader className="pb-3">
                <div className="flex justify-between items-start">
                  <CardTitle className="text-xl font-bold text-gray-900">
                    {specialty.title}
                  </CardTitle>
                  <div className="text-right">
                    <div className="text-lg font-bold text-primary">
                      {specialty.price}
                    </div>
                  </div>
                </div>
              </CardHeader>
              
              <CardContent>
                <CardDescription className="text-gray-600 leading-relaxed">
                  {specialty.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-white rounded-2xl p-8 shadow-elegant border border-pink-100 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              ✨ Chaque création est unique ✨
            </h3>
            <p className="text-gray-600 mb-6">
              Tous nos gâteaux sont personnalisables selon vos envies : saveurs, couleurs, 
              décorations et thèmes. Contactez-nous pour un devis sur mesure !
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="#contact"
                className="inline-flex items-center justify-center px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 transition-smooth font-medium"
              >
                Demander un devis
              </a>
              <a
                href="https://wa.me/33753797698"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-primary text-primary rounded-lg hover:bg-primary hover:text-white transition-smooth font-medium"
              >
                WhatsApp direct
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecialtiesSection;